import * as React from 'react'
import { tw } from 'utils/classnames'

import { Slot } from '../slot'

const TextRoot = function Text({
  ref,
  children,
  ...props
}: React.ComponentProps<'input'> & {
  ref?: React.RefObject<HTMLInputElement>
}) {
  return (
    <div className="relative text-gray-300">
      <input
        type="text"
        {...props}
        ref={ref}
        className={tw('rounded-2 w-full bg-gray-700 px-[6px] py-2 text-base', props.className)}
      />
      {children}
    </div>
  )
}

const TextIconRight = function TextIconRight({
  ref,
  asChild,
  ...props
}: AsChildGuard<'div', 'className' | 'children'> & {
  ref?: React.RefObject<HTMLDivElement>
}) {
  const Component = asChild ? Slot : 'div'

  return (
    <Component
      {...props}
      ref={ref}
      className={tw(
        'absolute inset-y-[3px] right-[3px] flex items-center justify-center text-gray-400 hover:text-gray-200',
        props.className,
      )}
    />
  )
}

export const Text = Object.assign(TextRoot, {
  Root: TextRoot,
  IconRight: TextIconRight,
})
